import { gql } from "apollo-boost";

export const FACILITY_MERGE = gql`
  mutation facilityMerge(
    $facilityId: Int
    $name: String!
    $desc: String!
    $contactInfo: String!
    $urlToDetails: String
    $type: String!
    $address: String!
    $city: String
    $countryId: Int
    $latitude: Float
    $longitude: Float
    $tag: String
    $userId: Int!
    $updateSource: String!
  ) {
    facilityMerge(
      data: {
        facilityId: $facilityId
        name: $name
        desc: $desc
        contactInfo: $contactInfo
        urlToDetails: $urlToDetails
        type: $type
        address: $address
        city: $city
        countryId: $countryId
        latitude: $latitude
        longitude: $longitude
        tag: $tag
        userId: $userId
        updateSource: $updateSource
      }
    ) {
      node {
        facilityId
        name
        desc
        contactInfo
        urlToDetails

        type
        address
        city
        countryId
        latitude
        longitude
        tag
        userId
        updateSource
        updateDate
      }
    }
  }
`;

export const FACILITY_DELETE = gql`
  mutation facilityDelete($id: Int!) {
    facilityDelete(id: $id) {
      status
    }
  }
`;
